import { Button } from 'antd';
import React from 'react';
import ActionArea from './ActionArea';

class LoopEnd extends ActionArea {
  constructor(props) {
    super(props);
    this.areaTitle = '结束后动作';
  }
  componentDidMount() {}

  getButtons = () => {
    return (
      <>
        <Button className="btn-small lightblue" type="primary" onClick={this.addAction}>
          添加动作
        </Button>
      </>
    );
  };
}

export default LoopEnd;
